/**
 * @generated SignedSource<<462ae82827341942a953ac341ecff9ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OpsDevicesPageQuery$variables = Record<PropertyKey, never>;
export type OpsDevicesPageQuery$data = {
  readonly devices: ReadonlyArray<{
    readonly actsAs: string | null | undefined;
    readonly createdAt: any;
    readonly id: string;
    readonly kind: string;
    readonly lastSeenAt: any | null | undefined;
    readonly name: string;
    readonly revokedAt: any | null | undefined;
  }>;
};
export type OpsDevicesPageQuery = {
  response: OpsDevicesPageQuery$data;
  variables: OpsDevicesPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Device",
    "kind": "LinkedField",
    "name": "devices",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actsAs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastSeenAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "revokedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsDevicesPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OpsDevicesPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "061a927bc7f0fefb88eba0f3543cddd3",
    "id": null,
    "metadata": {},
    "name": "OpsDevicesPageQuery",
    "operationKind": "query",
    "text": "query OpsDevicesPageQuery {\n  devices {\n    id\n    name\n    kind\n    actsAs\n    lastSeenAt\n    revokedAt\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f6bb9403f19a6a1ceda39a61825942c";

export default node;
